import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { FormQuestionState } from '@pixacare/forms';
import { ErrorIconComponent } from '@shared/components/error-icon/error-icon.component';

@Component({
  selector: 'pxc-form-grid-cell-error',
  templateUrl: './form-grid-cell-error.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ErrorIconComponent],
})
export class FormGridCellErrorComponent {
  readonly questionState = input.required<FormQuestionState>();
  readonly control = input.required<AbstractControl | null>();

  readonly showError = computed(() => {
    const state = this.questionState();
    const ctrl = this.control();
    const hasErrors = !state.isValid && !!state.errors?.length;
    return hasErrors && (state.isVisited || ctrl?.touched || ctrl?.dirty);
  });

  readonly errorMessages = computed(
    () =>
      this.questionState()
        .errors?.map((e) => e.message)
        .join('\n') ?? '',
  );
}
